import { api } from "../../App/services/api";
function getAllUsersArts(per_page, page) {
    var uri = "/arts/get-arts-for-user?limit=".concat(per_page);
    if (page) {
        uri += "&page=".concat(page);
    }
    return api.get(uri);
}
function getArtHistory(artId) {
    return api.get("/arts/ticket_history/".concat(artId));
}
function contestArt(payload) {
    return api.post('/arts/art_contestation', payload);
}
function sendCorrection(payload) {
    return api.post('/arts/send_correction', payload);
}
function paginate(url) {
    return api.get(url);
}
function storeManyArts(ArtsData) {
    return api.post('/arts/importArts', ArtsData);
}
function destroy(artsId) {
    return api.delete("/arts/".concat(artsId));
}
export default {
    getAllUsersArts: getAllUsersArts,
    getArtHistory: getArtHistory,
    contestArt: contestArt,
    sendCorrection: sendCorrection,
    paginate: paginate,
    storeManyArts: storeManyArts,
    destroy: destroy
};
